import Bestellung from "@/entities/common/bestellung"
import CheckoutOrder from "@/entities/common/checkout_order"
import RemoteResult from "@/entities/common/remote_result"
import CheckoutRequest from "@/entities/common/request/checkout_request"
import router from "@/router"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import BaseLogic from "../base_logic"

export default class BezahlenLogic extends BaseLogic {
  bestellung: Bestellung = null

  init() {
    this.bestellung = this.mainLogic.bestellung
  }

  weiter() {
    var request = new CheckoutRequest()
    request.id = this.bestellung.id
    request.checkoutMode = 1

    Poster.postUser<RemoteResult<CheckoutOrder>>(
      RestPaths.paymentPaypalCheckout,
      request
    ).then((response) => {
      if (response.data.success) {
        window.location.href =
          "https://www.sandbox.paypal.com/checkoutnow?token=" +
          response.data.payload.orderId
      }
    })
  }

  weiterTrinkgeld() {
    router.push({ name: RouteNames.BESTELLUNG_PAGE.TRINKGELD })
  }
}
